module.exports = __webpack_public_path__ + "img/95591723011234.639827e9.png";